import React, { Fragment } from 'react';
import { withTranslation } from "react-i18next";

import * as styles from './style.css';
import Icon from "../../../../icons/Icon";

import Div100vh from "../../../../uq-ui/components/div-100";
import LayoutComponentsHeader from '../../components/header';
import UQButton from '../../../../uq-ui/components/button';

const llama = require('./img/llama.png');

function ErrorScreen(props) {
  const onTryAgainPressed = () => {
    const stickerId = props.match.params.id;
    if (stickerId) {
      props.history.push(`/${stickerId}`);
    } else {
      props.history.push('/');
    }
  };
  return (
    <Fragment>
      <LayoutComponentsHeader showGreeting={true}
                              theme="light"/>
      <Div100vh className={styles.container}>
        <div className={styles.topContainer}>
          <div className={`${styles.title} font-title`}>{props.t('title')}</div>
          <div className={styles.subtitle}>{props.t('subtitle')}</div>
          <UQButton label={props.t('tryAgain')}
                    containerClass={styles.button}
                    theme={'brand'}
                    onPress={onTryAgainPressed}/>
        </div>
        <div className={styles.bottomContainer}>
          <div className={styles.supportEmail}>{props.t('email')}</div>
          <img src={llama} />
        </div>
      </Div100vh>
    </Fragment>
  );
}

export default withTranslation('scr-error')(ErrorScreen);


// WEBPACK FOOTER //
// ./src/app/modules/layout/ui/screens/error/index.jsx